<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25 md-small-size-100">
      <md-checkbox v-model="data.allow_student_counselor">{{
        $t("communication.also_send_to_students_counselor")
      }}</md-checkbox>
    </div>
    <div class="md-layout-item md-size-25 md-small-size-100" v-if="hasCheckBox">
      <md-checkbox v-model="data.allow_student_family">{{
        $t("communication.also_send_to_students_family")
      }}</md-checkbox>
    </div>
    <div class="md-layout-item md-size-25 md-small-size-100">
      <md-field>
        <label>{{ $t("communication.filter_by") }}</label>
        <md-select
          @md-selected="getListOptions"
          name="target"
          v-model="data.filter_by"
          id="target"
        >
          <md-option value="Class">{{ $t("common.class") }}</md-option>
          <md-option value="Student">{{
            $t("communication.student_name_student_id")
          }}</md-option>
        </md-select>
      </md-field>
    </div>
    <div
      class="md-layout-item md-size-25 md-small-size-100"
      :key="selectedIndex"
    >
      <selection-component
        v-if="data.filter_by"
        :label="data.filter_by"
        :data-list="dataList"
        :track-by="trackBy"
        :display-field="displayField"
        @update-selections="updateSelectionsData"
        @filtering="filterStdUsn"
        ref="selectionsRef"
      ></selection-component>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import SelectionComponent from "./../Selections";
import { getId } from "@/helpers/utils";
import { mapState } from "vuex";
export default {
  name: "student-option",
  components: {
    SelectionComponent
  },
  props: ["data", "hasCheckBox"],
  data() {
    return {
      selectedIndex: 0,
      trackBy: "",
      currentPath: "",
      displayField: "",
      dataList: [],
      gradeList: [],
      delayTime: null,
      query: {
        limit: 100
      }
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  methods: {
    getListOptions() {
      switch (this.data.filter_by) {
        case "Class": {
          this.currentPath = `${service_paths.users}/${getId(
            this.info
          )}/classes`;
          this.displayField = "name";
          this.trackBy = "id";
          this.getDataList();
          break;
        }
        case "Student": {
          this.currentPath = `${service_paths.users}/${getId(
            this.info
          )}/assigned-students`;
          this.displayField = "full_name";
          this.trackBy = "_id";
          this.query = Object.assign(
            {
              role_id: this.data.role_id,
              fields: ["full_name", "staff_code"]
            },
            this.query
          );
          this.getDataList();
          break;
        }
      }
      this.selectedIndex++;
    },
    setQuery(usnQuery) {
      if (this.data.filter_by === "Student") {
        return {
          key_search: usnQuery,
          limit: this.query.limit,
          fields: this.query.fields
        };
      }
      return {
        [`${this.displayField}__~`]: usnQuery,
        limit: this.query.limit
      };
    },
    filterStdUsn(usnQuery) {
      this.query = this.setQuery(usnQuery);
      clearTimeout(this.delayTime);
      this.delayTime = setTimeout(() => {
        this.$axios.get(this.currentPath, this.query).then(response => {
          this.dataList = response.data.data;
          const memorizedSelected = this.$refs.selectionsRef.getMemorizedSelected();
          memorizedSelected.forEach(studentSelected => {
            if (!this.dataList.includes(studentSelected))
              this.dataList.push(studentSelected);
          });
        });
      }, 200);
    },
    getDataList() {
      this.$axios
        .get(this.currentPath, { limit: this.query.limit })
        .then(response => {
          this.dataList = response.data.data;
        });
    },
    updateSelectionsData(e) {
      this.data.selectedList = e;
    }
  }
};
</script>
